import { Link } from 'react-router-dom';
import { Private_Routes } from '../../../../constants';
import { BonusAssignmentModel } from '../../models/bonusAssignmentModel';
import { useContext } from 'react';
import { AppContext } from '../../../../common';

interface Props {
    activeTab: string;
    setSelectedList: (item: BonusAssignmentModel[]) => void;
}

export const BonusTabs = ({ activeTab, setSelectedList }: Props) => {
    const { activeSkinConfig, langResources} = useContext(AppContext);

    return (
        <ul className='mb-4 nav nav-border-top nav-justified nav-tabs'>
            <li className='nav-item'>
                <Link
                    className={`nav-link${activeTab === 'employee' ? ' active' : ''}`}
                    to={Private_Routes.MANAGE_BONUS.index.replace(':tab', 'employee')}
                    onClick={() => setSelectedList([])}
                    style={
                        activeTab === 'employee'
                            ? { cursor: 'pointer', borderTop: `3px solid ${activeSkinConfig.principalColor}` }
                            : { cursor: 'pointer' }
                    }
                >
                    {langResources['bonus']['manage']['tab.by.employee']}
                </Link>
            </li>
            <li className='nav-item'>
                <Link
                    className={`nav-link${activeTab === 'date' ? ' active' : ''}`}
                    to={Private_Routes.MANAGE_BONUS.index.replace(':tab', 'date')}
                    onClick={() => setSelectedList([])}
                    style={
                        activeTab === 'date'
                            ? { cursor: 'pointer', borderTop: `3px solid ${activeSkinConfig.principalColor}` }
                            : { cursor: 'pointer' }
                    }
                >
                    {langResources['bonus']['manage']['tab.by.date']}
                </Link>
            </li>
        </ul>
    );
};